import { axios } from '@/utils/request'
import qs from 'qs'

export function getSign(){
  return axios({
    url: `/ws/oss`,
    method: 'get'
  })
}

export function getOutSign(){
  return axios({
    url: `/out/oss`,
    method: 'get'
  })
}

/**
 * 查看文件 ,一般是查看图片
 * @param id
 */
export function showFile(id){
  return axios({
    url: `/ws/oss/showFile`,
    method: 'get',
    params: {id:id}
  })
}

/**
 * 下载文件
 * @param id
 */
export function downLoadFile(id){
  return axios({
    url: `/ws/oss/downLoadFile`,
    method: 'get',
    params: {id:id},
    responseType: 'blob'
  })
}

/**
 * 下载文件
 * @param id
 */
export function downLoadFilesZip(idList){
  return axios({
    url: `/ws/oss/downLoadFilesZip`,
    method: 'get',
    params: { idList:idList },
    responseType: 'blob'
  })
}

export default{
  downLoadFile,
  downLoadFilesZip,
  showFile,
  getSign,
  getOutSign,
}